import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { IonModal } from '@ionic/angular';
import * as _ from 'lodash'

@Component({
  selector: 'app-time-picker',
  templateUrl: './time-picker.component.html',
  styleUrls: ['./time-picker.component.scss'],
})
export class TimePickerComponent implements OnInit {

  @Input() time: string //ISO HH:MM
  @Input() label: string // eg 'Start Time'
  @Input() minutesStep = 5 //step between minute values

  // triggered when the user picks a new time and presses okay
  @Output() timeChange = new EventEmitter()

  @ViewChild('timeModal') timeModal: IonModal

  minuteValues = ''

  constructor() { }

  ngOnInit() {
    if (this.time == undefined) {
      this.time = '12:00' //default to 12:00 if unset, ie in the middle
    }
    this.buildMinuteValues()
    console.debug('time picker init', this.time, this.minutesStep)
  }

  ngOnChanges() {
    console.debug('time picker update')
    // the minutesStep may have changed
    this.buildMinuteValues()
  }

  buildMinuteValues() {
    const values = _.range(0, 60, this.minutesStep)
    this.minuteValues = values.join(',')
  }

  present() {
    this.timeModal.present()
  }

  cancelClick() {
    this.timeModal.dismiss()
  }

  okClick() {
    if (this.timeChange) {
      this.timeChange.emit(this.time)
    }
    this.timeModal.dismiss()
  }
}
